const { h, render, Component } = require('preact');

class FileInput extends Component {
  constructor(props) {
    super(props);
    this.preventDefaults = this.preventDefaults.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.previewFile = this.previewFile.bind(this);
    this.handleCancelFileEvent = this.handleCancelFileEvent.bind(this);
  }

  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  highlight(e) {
    let dropArea = document.getElementById("drop_zone")
    dropArea.classList.add('drop-highlight')
  }

  unhighlight(e) {
    let dropArea = document.getElementById("drop_zone")
    dropArea.classList.remove('drop-highlight')
  }

  handleDrop(e) {
    var dt = e.dataTransfer
    var files = dt.files
    this.handleFiles(files)
  }

  handleFiles(files) {
    files = [...files]
    files.forEach(this.previewFile)
  }

  getFileFormat(file) {
    return file.name.split(".")[file.name.split(".").length - 1].toLowerCase()
  }

  previewFile(file) {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    let context = this
    reader.onloadend = function () {
      let acceptedFormats = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'csv', 'tiff']
      let maxSize = 1000000
      let currentFormat = context.getFileFormat(file)
      if (!acceptedFormats.includes(currentFormat) || file.size > maxSize) {
        context.setState({ 'error': I18n.translate('js.modules.support.invalid_file_message', { acceptedFormats: acceptedFormats, max_size: 1 }), 'selected': false, 'file_name': null })
      }
      else {
        context.props.changeFileUploadState(reader.result, file.name, true)
        context.setState({ 'selected': true, 'file_name': file.name, 'error': null })
      }
    }
  }


  componentDidMount() {
    let dropArea = document.getElementById("drop_zone");

    // Prevent default drag behaviors
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.preventDefaults, false)
      document.body.addEventListener(eventName, this.preventDefaults, false)
    });

    // Highlight drop area when item is dragged over it
    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.highlight, false)
    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.unhighlight, false)
    });

    // Handle dropped files
    dropArea.addEventListener('drop', this.handleDrop, false)
  }

  handleCancelFileEvent() {
    this.props.changeFileUploadState(null, null, false)
    this.setState({ 'selected': false, 'file_name': null, 'error': null })
  }

  render() {
    return (
      <div>
        <div id="drop_zone" class="drop_zone" >
          <div class="drop_zone_content">
            <label class="add-attachment">{I18n.translate('js.modules.web_2018.add_attachment')}</label> &nbsp;
            <label class="attachment-optional">{I18n.translate('js.modules.web_2018.optional_attachment')}</label>
          </div>
          {
            !this.state.selected ?
              (<div id="file_upload" class="file_upload_content">
                <label id="drop_file">{I18n.translate('js.modules.web_2018.drop_file')}</label> &nbsp;
              <input type="file" id="file_elem" onchange={(e) => this.handleFiles(e.target.files)} />
                <label id="choose_file" for="file_elem">{I18n.translate('js.modules.web_2018.choose_file')}</label>
              </div>) :
              (
                <div class="upload_container">
                  <div id="file_uploaded">
                    <label id="file_name" class="file_name">{this.state.file_name}</label>
                  </div>
                  <div class="file_icon_x">
                    {this.state.selected && <span class="icon-x" onClick={this.handleCancelFileEvent}></span>}
                  </div>
                </div>
              )
          }
          {(this.state.error && <label class="attachment-warning">{this.state.error}</label>)}
        </div>
      </div>
    )
  }
}

module.exports = FileInput
